
import React, { useState } from 'react';

// onLogin prop will be passed from App.js
function Login({ onLogin, error, setError }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginAsMaximus, setLoginAsMaximus] = useState(false); // New state for checkbox

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      // Call the handler passed from App.js
      await onLogin(email, password, loginAsMaximus);
    } catch (err) {
      // The parent component will now handle and display the error
      // This component just needs to know to display it.
      console.error("Error logging in:", err);
    }
  };

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '2.5rem', margin: 0 }}>BifrostKey</h1>
        <p style={{ fontSize: '1.2rem', margin: 0 }}>Admin Logg inn</p>
      </div>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="login-email" style={{ display: 'block', marginBottom: '5px' }}>E-post</label>
          <input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="login-password" style={{ display: 'block', marginBottom: '5px' }}>Passord</label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>
        <div style={{ margin: '10px 0' }}>
          <input
            type="checkbox"
            id="maximus-login"
            checked={loginAsMaximus}
            onChange={(e) => setLoginAsMaximus(e.target.checked)}
          />
          <label htmlFor="maximus-login" style={{ marginLeft: '5px' }}>Logg inn som Maximus Admin</label>
        </div>
        <button type="submit">Logg inn</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}

export default Login;
